<template>
  <div>
    <p v-if="state.noData">No Data</p>

    <v-row
      class="fill-height"
      align-content="center"
      justify="center"
      v-if="state.loading"
    >
      <v-col class="text-subtitle-1 text-center" cols="12">
        Loading Data
      </v-col>
      <v-col cols="6">
        <v-progress-linear
          color="deep-purple accent-4"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
      </v-col>
    </v-row>

    <template v-if="!state.noData && !state.loading && data.kv">
      <main class="report" id="section-print">
        <div class="header">
          <div class="left">
            <h2 class="report-title">
              {{ companyName }} - Info Data Bill of Landing
            </h2>
            <div class="report-info">
              <div class="vessel">
                <p>
                  Vessel: <b>{{ data.vessel }}</b>
                </p>
              </div>
              <div class="kv">
                <div>{{ data.kv }}</div>
              </div>
              <div class="tgl">
                <p>
                  Tgl Berangkat: <b>{{ tgl_berangkat }}</b>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div
          v-for="(kondisi_stuffing, key) in data.kondisi_stuffing"
          class="mb-5"
        >
          <p class="mb-0">
            Kondisi Stuffing:
            <b
              ><i>{{ key }}</i></b
            >
          </p>

          <table width="100%" class="mb-2">
            <thead>
              <th width="25%">Shiper u/ Consignee</th>
              <th width="10%"></th>
              <th width="15%">No Cont</th>
              <th width="10%">Seal</th>
              <th width="15%">Cargo</th>
              <th width="25%">Tujuan</th>
            </thead>
            <tbody>
              <tr v-for="container in kondisi_stuffing" :key="container.id">
                <td>{{ container.bl || "-" }}</td>
                <td>{{ container.jenis_container }}</td>
                <td>{{ container.no_container }}</td>
                <td>{{ container.no_seal }}</td>
                <td>{{ container.cargo }}</td>
                <td>{{ container.port_tujuan }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <footer>
          <div class="total">
            <h3>Total Container: {{ totalContainerKeseluruhan }}</h3>
            <h3>Total B/L: {{ data.total_bl }}</h3>
          </div>
          <div class="sign">
            <p>Hormat Kami,</p>
          </div>
        </footer>
      </main>

      <section id="pelunasan" class="mt-3">
        <div class="card">
          <v-card tile>
            <v-card-text class="p-1">
              <v-row>
                <v-col cols="12" md="12">
                  <PelunasanBL
                    v-for="(biaya, i) in formData.biaya"
                    :biaya="biaya"
                    :i="i"
                    @delete="deleteRow"
                  />
                  <v-row>
                    <v-col cols="12" md="8"></v-col>
                    <v-icon style="visibility: hidden">mdi-equal</v-icon>
                    <v-icon>mdi-equal</v-icon>
                    <v-col cols="12" md="3">
                      <v-text-field
                        label="Total"
                        outlined
                        dense
                        small-chips
                        hide-details
                        disabled
                        v-model="totalBiaya"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-btn
                    small
                    color="primary"
                    class="w-100 mt-1"
                    @click="addRow()"
                    >Tambah Biaya Baru</v-btn
                  >
                </v-col>
              </v-row>
              <v-text-field
                label="Terbilang"
                outlined
                dense
                small-chips
                hide-details
                class="mt-5"
                disabled
                v-model="terbilang"
              ></v-text-field>
              <div class="d-flex justify-end">
                <v-btn
                  color="success"
                  class="right mt-4"
                  @click="processPelunasan()"
                  >Save Pelunasan</v-btn
                >
              </div>
            </v-card-text>
          </v-card>
        </div>
      </section>
    </template>

    <PelunasanBlModal
      :openModal="!formData.kv"
      @close-modal="fetchDataPelunasanBL"
    />

    <!-- Save Button -->
    <v-btn
      class="mx-2"
      fab
      dark
      right
      bottom
      fixed
      color="success"
      @click="resetPelunasan"
    >
      New
    </v-btn>
  </div>
</template>

<script>
import axios from "axios";
import variableMixin from "@/mixins/variableMixin";

export default {
  mixins: [variableMixin],
  data() {
    return {
      state: {
        loading: false,
        noData: false,
        process: false
      },
      formData: {
        kv: "",
        biaya: [
          {
            jumlah: 0,
            satuan: "",
            harga: 0,
            total: 0
          }
        ]
      },
      totalBiaya: 0,
      terbilang: "",
      data: {},
      months: [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember"
      ],
      days: ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"]
    };
  },
  components: {
    PelunasanBL: () => import("@/components/PelunasanBL/PelunasanBL.vue"),
    PelunasanBlModal: () =>
      import("@/components/PelunasanBL/PelunasanBLModal.vue")
  },
  computed: {
    today() {
      let date = new Date();
      let day = date.getDay();
      let month = date.getMonth();
      let year = date.getFullYear();

      return `${this.days[day]}, ${date.getDate()} ${
        this.months[month]
      } ${year}`;
    },
    tgl_berangkat() {
      let date = new Date(this.data.tgl_berangkat);
      let day = date.getDay();
      let month = date.getMonth();
      let year = date.getFullYear();

      return `${this.days[day]}, ${date.getDate()} ${
        this.months[month]
      } ${year}`;
    },
    totalContainerKeseluruhan() {
      let total = 0;

      for (let key in this.data.kondisi_stuffing) {
        total += this.data.kondisi_stuffing[key].length;
      }

      return total;
    }
  },
  watch: {
    "formData.kv"(val) {
      if (val) {
        this.formData.kv = val.toUpperCase();
      }
    },
    "formData.biaya": {
      handler: function(val) {
        let total = 0;

        val.forEach(element => {
          total += element.harga * element.jumlah;
        });

        this.totalBiaya = this.formatCurrency(total);
        this.terbilang = this.pembilang(total);
      },
      deep: true
    }
  },
  methods: {
    async processPelunasan() {
      this.state.process = true;

      await axios
        .post("pelunasan-bl/process", this.formData)
        .then(res => {
          this.state.process = false;

          this.resetPelunasan();
        })
        .catch(err => {
          this.state.process = false;

          alert(err.response.data.message);
        });
    },
    fetchDataPelunasanBL(val) {
      this.formData.kv = val.kv;

      if (val.pelunasan) {
        this.formData.biaya = val.pelunasan.detils || [];
      }

      if (!val.info_bl.kv) {
        this.state.noData = true;
      } else {
        this.state.noData = false;
        this.data = val.info_bl;
      }
    },
    async generateInfoBL() {
      this.state.loading = true;

      await axios
        .get(`pelunasan-bl/info-bl?kv=${this.formData.kv}`)
        .then(res => {
          if (!res.data.kv) {
            this.state.noData = true;
          } else {
            this.state.noData = false;
            this.data = res.data;
          }

          this.state.loading = false;
        })
        .catch(err => {
          this.state.loading = false;

          alert(err.response.data.message);
        });
    },
    addRow() {
      this.formData.biaya.push({
        jumlah: 0,
        satuan: "",
        harga: 0,
        total: 0
      });
    },
    deleteRow(index) {
      this.formData.biaya.splice(index, 1);
    },
    resetPelunasan() {
      this.formData = {
        kv: "",
        biaya: [
          {
            jumlah: 0,
            satuan: "",
            harga: 0,
            total: 0
          }
        ]
      };

      this.data = {};
    },
    formatCurrency(num) {
      return new Intl.NumberFormat("id-ID").format(num);
    },
    convertToAngka(nilai) {
      if (nilai == "0" || nilai == "" || nilai == null) return 0;

      let desimal = nilai.split(",")[1];
      let angka = nilai
        .split(",")[0]
        .split(".")
        .join("");
      return parseFloat(`${angka}.${desimal}`);
    },
    pembilang(nilai) {
      const _isNominalValid = nilai => {
        const regex = new RegExp(/^\d+$/);
        return !regex.test(nilai);
      };
      const _nominalWording = nilai => {
        const UNIQUE_TWELVE = 12;
        const UNIQUE_TWENTY = 20;
        const UNIQUE_TWO_HUNDRED = 200;
        const UNIQUE_TWO_THOUSAND = 2000;
        const UNIQUE_NAMING = [
          "",
          "Satu ",
          "Dua ",
          "Tiga ",
          "Empat ",
          "Lima ",
          "Enam ",
          "Tujuh ",
          "Delapan ",
          "Sembilan ",
          "Sepuluh ",
          "Sebelas "
        ];
        const TEN = 10;
        const ONE_HUNDRED = 100;
        const ONE_THOUSAND = 1000;
        const ONE_MILLION = 1000000;
        const ONE_BILLION = 1000000000;
        const ONE_TRILLION = 1000000000000;
        if (nilai < ONE_HUNDRED) {
          if (nilai < UNIQUE_TWELVE) return UNIQUE_NAMING[nilai];
          if (nilai < UNIQUE_TWENTY)
            return _nominalWording(nilai % TEN) + "Belas ";
          return (
            _nominalWording(Math.floor(nilai / TEN)) +
            "Puluh " +
            _nominalWording(nilai % TEN)
          );
        }
        if (nilai < ONE_THOUSAND) {
          if (nilai < UNIQUE_TWO_HUNDRED)
            return "Seratus " + _nominalWording(nilai % ONE_HUNDRED);
          return (
            _nominalWording(Math.floor(nilai / ONE_HUNDRED)) +
            "Ratus " +
            _nominalWording(nilai % ONE_HUNDRED)
          );
        }
        if (nilai < ONE_MILLION) {
          if (nilai < UNIQUE_TWO_THOUSAND)
            return "Seribu " + _nominalWording(nilai % ONE_THOUSAND);
          return (
            _nominalWording(Math.floor(nilai / ONE_THOUSAND)) +
            "Ribu " +
            _nominalWording(nilai % ONE_THOUSAND)
          );
        }
        if (nilai < ONE_BILLION)
          return (
            _nominalWording(Math.floor(nilai / ONE_MILLION)) +
            "Juta " +
            _nominalWording(nilai % ONE_MILLION)
          );
        return (
          _nominalWording(Math.floor(nilai / ONE_BILLION)) +
          "Miliar " +
          _nominalWording(nilai % ONE_BILLION)
        );
      };
      if (_isNominalValid(nilai)) return "Nol Rupiah";

      return _nominalWording(nilai) + "Rupiah";
    }
  }
};
</script>

<style lang="css" scoped>
.report {
  background-color: white;
  width: 100%;
  font-family: times;
  padding: 20px;
  color: black;
}

.report .report-title {
  border-bottom: 1px solid black;
}

.header {
  display: flex;
  justify-content: space-between;
}

.header .left {
  width: 100%;
}

.header .right {
  width: 20%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.right p {
  font-size: 12px;
}

.report-info {
  display: flex;
  margin-top: 1rem;
  justify-content: space-between;
}

.report-info p {
  font-style: italic;
}

.report-info .kv {
  padding: 0 5px;
  height: fit-content;
  border: 1px solid black;
}

table {
  border-bottom: 1px solid black;
}

table th {
  text-align: left;
}

footer {
  display: flex;
  justify-content: space-between;
}

.sign p {
  margin-right: 150px;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
